import React from 'react';
import { Box, CircularProgress, CircularProgressProps, Typography } from '@mui/material';

type TProps = CircularProgressProps & {
  /** Progress from 0 to 100, shown as a percentage in the middle of the circle */
  value: number;
};

/**
 * A determinate circular progress with its percentage in the middle, as in the MUI docs:
 * https://mui.com/material-ui/react-progress/#circular-with-label
 */
export const CircularProgressWithLabel: React.FC<TProps> = props => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="text.secondary">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
};
